import { render, staticRenderFns } from "./Siderbar.vue?vue&type=template&id=0cc417a5&scoped=true"
import script from "./Siderbar.vue?vue&type=script&lang=js"
export * from "./Siderbar.vue?vue&type=script&lang=js"
import style0 from "./Siderbar.vue?vue&type=style&index=0&id=0cc417a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc417a5",
  null
  
)

export default component.exports